import React, {FC, Fragment} from "react";
import ProductImage from "../ProductImage";
import ProductColumnInfo from "../ProductColumnInfo";
import Currency from "../../../shared/Currency";
import InputNumber from "../../../shared/InputNumber";
import RemoveButton from "../RemoveButton";
import {ICartItemType} from "../../../../types/state";
import {quantitiesType} from "../../ShopPageCart";
import cls from "../../shop.module.scss";
import {useToast} from "../../../../atoms/Toast/useToast";
import {FailSvg} from "../../../../svg";

interface IMainProps {
    item: ICartItemType;
    DeleteIntl: string;
    onChangeCallBack: (quantity: number, item: ICartItemType) => void;
    quantities: quantitiesType[]
    maxQty: number;
    ProductNotAvailableIntl: string
}

const Main:FC<IMainProps> = ({item, DeleteIntl, onChangeCallBack, maxQty, quantities, ProductNotAvailableIntl}) => {
    const {
        product,
        options,
        formated_base_price: formattedProductPrice,
        id: itemId
    } = item;
    const toast = useToast();
    const clsHandle = (tabName: string) => ({
        className: `${cls["cart-table__column"]} ${cls[`cart-table__column--${tabName}`]}`
    })
    const quantityFindToggle = () => {
        const {
            value = item.quantity,
            min_qty = 1
        } = quantities.find(qty => qty.itemId === itemId) || {}
        return { value, min_qty };
    }
    const onChange = (quantities: number) => {
        if (maxQty <= quantities) {
            return toast.open(
                <span className="d-flex chek-fms">
                    <FailSvg/>
                    {ProductNotAvailableIntl}
                </span>
            )
        } else {
            if (quantities !== 0) {
                return onChangeCallBack(quantities, item)
            }
        }
    }
    return (
        <Fragment>
            <td {...clsHandle("image")}>
                <ProductImage item={item}/>
            </td>
            <td {...clsHandle("product")}>
                <ProductColumnInfo product={product} options={options}/>
            </td>
            <td {...clsHandle("price")}>
                <Currency value={formattedProductPrice}/>
            </td>
            <td {...clsHandle("quantity")}>
                <InputNumber
                    onChange={onChange}
                    hideMiusButton={
                        quantityFindToggle().value <= 1
                        || quantityFindToggle().min_qty === quantityFindToggle().value
                    }
                    value={quantityFindToggle().value}
                    min={quantityFindToggle().min_qty}
                    max={maxQty}
                    alternativelyRemoveButton={
                        <RemoveButton isAlternative={true} cartItemId={itemId} DeleteIntl={DeleteIntl}/>
                    }
                />
            </td>
        </Fragment>
    )
}
export default Main;